import { features } from '@/mocks/yy';

export default function Features() {
  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-command-line" aria-hidden="true"></i>
            核心功能
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">一次登录，玩转多元娱乐</h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            通过歪歪官方网站登录后，即可解锁丰富玩法，从直播到语音，从游戏到交友，满足你不同时刻的娱乐需求。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <article key={f.title} className="group rounded-lg bg-background-50 border border-background-200 p-6 hover:border-primary-200 transition-colors">
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-md bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${f.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}